
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kosLT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b2df2daac61f0d97$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $b2df2daac61f0d97$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Todos los sitios',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Cerrar',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(no disponible en estos momentos)',
    'navigation.global-shortcuts.sites': 'Sitios de {productName}'
};

});


//# sourceMappingURL=es.fa9ff953.js.map
